<template src="./index.html"></template>

<script>
	import bus from '../../util/bus';
	import data from './data.js';
	import AboutUs from '../../page/AboutUs/index.vue';
	import {
		sysindex,
		loginOut
	} from '../../../api/home.js';
	export default {
		components: {
			AboutUs
		},
		data() {
			return {
				heightKAng: '0px',
				introduceshow: false,
				userName: '',
				options: [{
						label: '退出登录',
						value: 'loginout'
					}
					// {
					// 	label: '修改密码',
					// 	value: 'ChangePassword'
					// }
				],
				yisop: false,
				wholeData: [{
						name: '发票通销项V5.0',
						letter: '支持数电发票和税控发票一体化管理，帮助企业将业务数据自动转换为标准开票数据，按需拆分、合并，提升企业对开票、抄报税等的全流程掌控能力。',
						url: 'A1',
						enable: '1',
						indexUrl: 'https://t.taxunion.cn:20143/#/Login',
						key: 'ei5'
					},
					{
						name: '发票通v2.0',
						letter: '集中管控企业进销项发票，提供发票快捷采集识别、真伪查验与一键抵扣认证等功能，帮助企业将业务数据自动转换为标准开票数据，提升开票效率。',
						url: 'A2',
						enable: '0',
						indexUrl: '',
						key: 'saas'
					},
					{
						name: '易开票',
						letter: '业务人员在外可随时发起开票申请，通过快捷审批后立即开票给交易对手，减少内部线下沟通以及开票差错、提升经营效率。',
						url: 'A3',
						enable: '0',
						indexUrl: '',
						key: 'ykp'
					},
					{
						name: '易收票',
						letter: '通过手机小程序快速采集发票，包括拍照识别、扫码解析、微信卡包拉取等方式，支持一键查验并快速获取结果，随时随地管理进项发票。',
						url: 'A4',
						enable: '1',
						indexUrl: '',
						key: ''
					},
					// {
					// 	name: '扫码开票',
					// 	letter: '通过手机小程序快速采集发票，包括拍照识别、扫码解析、微信卡包拉取等方式，支持一键查验并快速获取结果，随时随地管理进项发票。',
					// 	url: 'A5',
					// 	enable: '0',
					// 	indexUrl: '',
					// 	key: 'smkp'
					// },
					{
						name: '票必达',
						letter: '纸电票、单据均可通过预置客户分派规则，以邮件、微信卡包、短信等方式进行智能电子影像交付，并返回签收结果，减少人工重复操作和线下沟通成本。',
						url: 'A6',
						enable: '0',
						indexUrl: '',
						key: 'eid'
					},
					{
						name: '数字化财税协同',
						letter: '通过统一平台操作，帮助企业与供应商高效对账、结算及开票，提升发票达标率并自动匹配到业务单据，缩短企业与供应商之间的对账周期，降低成本。',
						url: 'A7',
						enable: '0',
						indexUrl: '',
						key: 'szhcsxt'
					},
					{
						name: '数信通',
						letter: '数信通可以帮助企业快速、高效地管理发票，实现数据的可视化管理和统计。支持多种方式从电子发票平台获取已开具和已收到的数电、税控发票信息，并能够生成各类汇总报表，方便用户进行数据分析。',
						url: 'A8',
						enable: '1',
						indexUrl: 'https://sxt.taxunion.com.cn/digitalize/web/#/Login',
						key: 'sxt'
					},
					{
						name: '税务网关监控',
						letter: '税务网关监控帮助企业集中监控税务相关的各个网关运行情况，实时记录网关工作数据。支持统计网关工作量，下载开票对账单，查看、下载以及转存网关日志等，帮助企业快速核对数据排查异常。',
						url: 'A9',
						enable: '0',
						indexUrl: '',
						// indexUrl: 'http://106.14.81.90:8193/TGM/#/login',
						key: 'swwgjk'
					},
					{
						name: '财税中台',
						letter: '',
						url: 'A10',
						enable: '0',
						indexUrl: '',
						key: 'caiszt'
					}
				],
				wisdomData: [{
						name: '纳税申报',
						letter: '全税种、全流程的申报管控，包括数据采集与治理、审核内容交叉比对、指标预警、一键申报并缴款、最新政策查阅、税务风险防控等。',
						url: 'B1',
						enable: '1',
						indexUrl: 'https://test_nssb.taxunion.com.cn/#/login',
						key: 'nssb'
					},
					{
						name: '财务本地化',
						letter: '专为跨国企业解决中国本土财务合规问题，通过外方账薄自动映射转化成中方账管理，并生成满足税务、审计及管理所需的中方凭证与报表等。',
						url: 'B2',
						enable: '0',
						indexUrl: '',
						key: 'fvm'
					},
					{
						name: '档管家',
						letter: '与各业务系统打通，自动高效归集企业会计档案并长期存储，支持有权限人员快速定位查阅，满足电子会计档案真实、完整、可用、安全的四性要求。',
						url: 'B3',
						enable: '0',
						indexUrl: '',
						key: 'dgj'
					}
				],
				ShanxzData: [{
					name: '知识库',
					letter: '税慧盟知识库',
					url: 'C1',
					enable: '1',
					indexUrl: 'http://106.14.81.90/digitalize/taxInformation',
				}, {
					name: '版式转换',
					letter: '发票版式转换',
					url: 'C2',
					enable: '1',
					indexUrl: 'http://139.196.59.37/ofd/#/',
				}, {
					name: '熊说会道',
					letter: 'AI对话助手',
					url: 'C3',
					enable: '1',
					indexUrl: 'https://www.taxunion.cn/AI/#/',
				}, ],
				imgData: ['bannerxin.svg', 'banner8.svg']
			};
		},
		created() {
			this.initialize();
		},
		mounted() {
			this.heightadaptivity();
			window.addEventListener('resize', () => {
				this.$nextTick(()=>{
					this.heightadaptivity();
				})
			});
			
		},
		methods: {
			heightadaptivity() {
				setTimeout(() => {
					const element = document.querySelector('.inagkq');
					const height = element.clientHeight;
					this.heightKAng = height + 'px'
				}, 100)
			},
			getRequestParam() {
				//  获取请求后面的参数
				var requestParam = new Object();
				if (location.href.indexOf('?') != -1) {
					var url = location.href.substring(location.href.indexOf('?')); //获取url中"?"符后的字串
					var str = url.substr(1);
					let strs = str.split('&');
					for (var i = 0; i < strs.length; i++) {
						requestParam[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[
							1
						]); //获取中文参数转码<span style="font-family: Arial, Helvetica, sans-serif;">decodeURI</span>，（unescape只针对数字，中文乱码)
					}
				}
				return requestParam;
			},
			forheadchange(e) {
				console.log(e);
				if (e == 'loginout') {
					let params = {
						token: localStorage.getItem('token')
					};
					loginOut(params).then(res => {
						localStorage.removeItem('token');
						this.$router.push('/Login');
					});
				}
			},
			jumpLink(e) {
				if (e.enable == '1') {
					if (e.name == '易收票') {
						this.yisop = true;
					} else {
						window.open(e.indexUrl);
					}
				}
			},
			initialize() {
				let t = localStorage.getItem('token');
				if (t == null || t == '') {
					let param = this.getRequestParam();
					if (param && param['token']) {
						t = param['token'];
						localStorage.setItem('token', t);
					}
				}
				if (t != '' && t != null) {
					let params = {
						token: t
					};
					sysindex(params).then(res => {
						console.log(res.data);
						if (res.data.code == '200') {
							this.userName = res.data.data.userName;
							this.wholeData.map(v => {
								if (v.key != '') {
									res.data.data.list.forEach(vv => {
										if (v.key == vv.key) {
											v.enable = vv.enable;
											v.indexUrl = vv.indexUrl;
										}
									});
								}
								return v;
							});
							this.wisdomData.map(v => {
								if (v.key != '') {
									res.data.data.list.forEach(vv => {
										if (v.key == vv.key) {
											v.enable = vv.enable;
											v.indexUrl = vv.indexUrl;
										}
									});
								}
								return v;
							});
						} else {
							this.$message.error(res.data.message);
						}
					});
				} else {
					localStorage.removeItem('token');
					this.$router.push('/Login');
				}
			},
			introduce_show() {
				this.introduceshow = true;
			},
			introduce_shidden() {
				this.introduceshow = false;
			}
		}
	};
</script>

<style scoped lang="less">
	@import url('index.less');
</style>

<style scoped lang="less">
	.bodybox_s/deep/.el-input--small .el-input__inner {
		border: none;
		background-color: #354257;
		border-radius: 16px;
	}

	@media screen and (max-width: 1024px) {
		.imgda {
			display: none;
		}

		.imgxiaohao {
			width: 100%;
			margin-bottom: 40px;
			display: block;
		}
	}

	@media screen and (min-width: 1024px) {
		.imgda {
			width: 100%;
			margin-bottom: 40px;
			display: block;
		}

		.imgxiaohao {
			display: none;
		}
	}
</style>